"use client";

import { RiHeartFill, RiHeartLine } from "@remixicon/react";
import { cn } from "@workspace/ui/lib/utils";
import { useState } from "react";

interface ReviewLovedButtonProps {
	loved: boolean;
	onChange: (newLovedState: boolean) => void;
	readOnly?: boolean;
}

export function ReviewLovedButton({
	loved,
	onChange,
	readOnly = false,
}: ReviewLovedButtonProps) {
	const [heartHover, setHeartHover] = useState(false);

	const handleClick = (e: React.MouseEvent) => {
		if (readOnly) return;
		e.stopPropagation();
		onChange(!loved);
		setHeartHover(false);
	};

	return (
		<button
			type="button"
			onClick={handleClick}
			onMouseEnter={() => !readOnly && setHeartHover(true)}
			onMouseLeave={() => setHeartHover(false)}
			onTouchStart={() => {
				if (!readOnly) setHeartHover(true);
			}}
			onTouchCancel={() => setHeartHover(false)}
			className={cn(
				"relative flex cursor-pointer touch-manipulation items-center justify-center",
				"h-11 w-11 md:h-12 md:w-12", // Match stars container size
				readOnly && "pointer-events-none",
			)}
			title={loved ? "Unlove this" : "Love this"}
			aria-pressed={loved}
			disabled={readOnly}
		>
			{/* Heart icon with Rombo animations */}
			<span
				className={cn(
					"absolute inset-0 flex items-center justify-center",
					loved && "",
					!loved && heartHover && "",
				)}
			>
				{loved || heartHover ? (
					<RiHeartFill
						className={cn("h-[65%] w-[65%] text-red-500")}
						aria-hidden="true"
					/>
				) : (
					<RiHeartLine
						className={cn("h-[65%] w-[65%] text-muted-foreground/30")}
						aria-hidden="true"
					/>
				)}
			</span>
		</button>
	);
}
